import { onCleanup, onMount } from "solid-js"
import { mapController } from "../map/controller"
import { app } from "../store/app"

export function MapView() {
  let mapEl!: HTMLDivElement

  onMount(() => {
    mapController.init(mapEl)
    mapController.bind({
      isRouteEnabled: (routeId) => app.isRouteEnabled(routeId),
      onVehicleClick: (vehicleId) => app.openVehicle(vehicleId, true),
      onRouteClick: (routeId) => app.openRoute(routeId, true),
      getVehicles: () => app.vehicles(),
      getSelected: () => ({
        routeId: app.selectedRouteId(),
        vehicleId: app.selectedVehicleId(),
      }),
      getRouteColor: (routeId, fallback) => app.routeColor(routeId, fallback),
      onDragStart: () => app.setFollowVehicle(false),
    })

    app.bootstrap()
      .then(() => app.startPolling())
      .catch(console.error)

    const onResize = () => mapController.invalidate()
    window.addEventListener("resize", onResize)
    onCleanup(() => window.removeEventListener("resize", onResize))
  })

  return <div id="map" ref={mapEl} />
}
